import axios from "axios";


const GetGradeList = async () => {
  return axios.get(`Grade/GetGrades`).then((response) => response);
};


const AddGrade = async (payload) => {
  const config = {
    method: "post",
    url: `Grade/AddGrade`,
    headers: { "Content-Type": "application/json" },
    data: payload,
  };
  return axios.request(config).then((response) => response);
};


const UpdateGrade = async (payload) => {
  const config = {
    method: "post",
    url: `Grade/UpdateGrade`,
    headers: { "Content-Type": "application/json" },
    data: payload,
  };
  return axios.request(config).then((response) => response);
};

const gradeService = {
  GetGradeList,
  AddGrade,
  UpdateGrade,
};

export default gradeService;
